import * as React from "react";
import classNames from "classnames";
import "./CPFontAwesomeStyles.scss";

interface CPFontAwesomeProps {
  /** Font Awesome icon class string, e.g. `"fa-solid fa-user"` or `"fa-regular fa-circle-xmark"`. */
  icon?: string;
  /** URL to an SVG file used as a fallback when the CSS icon font is unavailable (e.g. brands icons not loaded via SCSS). */
  svgFallback?: string;
  /** Inline styles applied to the fallback SVG `<img>` element. */
  svgStyle?: React.CSSProperties;
  /** Inline styles merged onto the wrapping element. */
  style?: React.CSSProperties;
  /** Font size of the icon — number (px) or any valid CSS font-size string. */
  size?: number | string;
  /** When `true`, renders the wrapping `div` as `display: inline-block` instead of the default inherited display. */
  inline?: boolean;
}

/**
 * Thin wrapper for rendering Font Awesome icons. Accepts any FA icon class and exposes
 * `size`, `style`, and `inline` convenience props.
 *
 * @example
 * ```tsx
 * // Solid icon at default size
 * <CPFontAwesome icon="fa-solid fa-user" />
 *
 * // Custom size, inline
 * <CPFontAwesome icon="fa-regular fa-envelope" size={20} inline />
 *
 * // Custom style
 * <CPFontAwesome icon="fa-solid fa-check" style={{ color: 'green' }} />
 * ```
 */
const CPFontAwesome: React.FC<CPFontAwesomeProps> = ({
  icon,
  svgFallback,
  svgStyle,
  style,
  size,
  inline,
}) => {
  return (
    <div
      className="cp-font-awesome"
      style={{
        //minWidth: "30px",
        ...style,
        fontSize: size,
        display: inline ? "inline-block" : "inherit",
      }}
    >
      {svgFallback ? (
        <img
          src={svgFallback}
          aria-hidden="true"
          alt=""
          style={{
            width: "1em",
            height: "1em",
            verticalAlign: "middle",
            ...svgStyle,
          }}
        />
      ) : (
        <i className={classNames(icon)}></i>
      )}
    </div>
  );
};

export default CPFontAwesome;
